import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import api from "../../utils/api";
import {toast} from "react-toastify";
import {buildQueryString} from "../../utils/buildQueryString";

const WiseBerryAPIEnv = process.env.VITE_API_KEY;

export const getAllAppointment = createAsyncThunk(
  "diary/getAllAppointment",
  async ({for_contact, from, limit, to}, {rejectWithValue}) => {
    try {
      let queryString = buildQueryString({
        for_contact,
        from,
        limit,
        to,
      });
      // debugger;

      const res = await api.get(`${WiseBerryAPIEnv}appointment?${queryString}`);
      return res.data.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);
export const getAppointmentType = createAsyncThunk(
  "diary/getAppointmentTypes",
  async (_, {rejectWithValue}) => {
    try {
      const res = await api.get(`${WiseBerryAPIEnv}menu?name=appointment_type`);
      let allowedIds = [5, 6, 4, 2, 25, 1, 3, 23, 24, 15, 8];
      let allowedList = res.data.data.appointment_type?.filter((item) =>
        allowedIds.includes(item.id)
      );

      return allowedList;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);

export const getListings = createAsyncThunk(
  "diary/getListings",
  async (_, {rejectWithValue}) => {
    try {
      const res = await api.get(`${WiseBerryAPIEnv}listing?limit=1000&state=1`);
      return res.data.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);
export const getRentals = createAsyncThunk(
  "diary/getRentals",
  async (_, {rejectWithValue}) => {
    try {
      const res = await api.get(
        `${WiseBerryAPIEnv}rental?limit=1000&contract_in_office=1&status=1`
      );
      return res.data.data;
    } catch (err) {
      if (err.response && err.response.status === 401) {
        toast.error("Please Login, Authorization Denied");
      }
      return rejectWithValue(err.message);
    }
  }
);

export const addAppointment = createAsyncThunk(
  "diary/add_appointment",
  async (obj, {}) => {
    try {
      const res = await api.post(`${WiseBerryAPIEnv}appointment`, obj);

      if (res.data) {
        toast.success(res.data.message);
      }
      return res.data.data;
      //   dispatch(loadUser(res.data?.data?.original.data.contact_id));
    } catch (err) {
      if (err.response && err.response.data) {
        throw new Error(err.response.data.message);
      }
      throw new Error(err.message);
    }
  }
);
export const updateAppointment = createAsyncThunk(
  "diary/update_appointment",
  async (obj, {}) => {
    // debugger;
    const {id, formData} = obj;
    formData.append("_method", "PATCH");
    try {
      const res = await api.post(
        `${WiseBerryAPIEnv}appointment/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data) {
        toast.success(res.data.message);
      }
      return res.data.data;
      //   dispatch(loadUser(res.data?.data?.original.data.contact_id));
    } catch (err) {
      if (err.response && err.response.data) {
        throw new Error(err.response.data.message);
      }
      throw new Error(err.message);
    }
  }
);

let initialState = {
  appointments: [],
  loading: false,
  appointmentsError: null,
  appointmentType: [],
  listings: [],
  loadingListing: false,
  listingError: null,
  loadingType: false,
  appointmentTypeError: null,
  newAppointment: null,
  newAppointmentError: null,
  newAppointmentLoading: false,
  updateApp: {},
  updateAppError: null,
  rentals: [],
  loadingRentals: false,
  rentalsError: null,
};

const todoSlice = createSlice({
  name: "todo",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllAppointment.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllAppointment.fulfilled, (state, action) => {
        state.appointments = action.payload;
        state.loading = false;
        state.appointmentsError = null;
      })
      .addCase(getAllAppointment.rejected, (state, action) => {
        state.loading = false;
        state.appointmentsError = action.payload;
        state.appointments = [];
      })
      .addCase(getAppointmentType.pending, (state) => {
        state.loadingType = true;
      })
      .addCase(getAppointmentType.fulfilled, (state, action) => {
        state.appointmentType = action.payload;
        state.loadingType = false;
        state.appointmentTypeError = null;
      })
      .addCase(getAppointmentType.rejected, (state, action) => {
        state.appointmentType = null;
        state.loadingType = false;
        state.appointmentTypeError = action.payload;
      })
      .addCase(addAppointment.pending, (state) => {
        state.newAppointmentLoading = true;
      })
      .addCase(addAppointment.fulfilled, (state, action) => {
        state.newAppointment = action.payload;
        state.newAppointmentLoading = false;
        state.newAppointmentError = null;
      })
      .addCase(addAppointment.rejected, (state, action) => {
        state.newAppointment = null;
        state.newAppointmentLoading = false;
        state.newAppointmentError = action.payload;
      })
      .addCase(updateAppointment.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateAppointment.fulfilled, (state, action) => {
        state.updateApp = action.payload;
        state.loading = false;
        state.updateAppError = null;
      })
      .addCase(updateAppointment.rejected, (state, action) => {
        state.updateApp = null;
        state.loading = false;
        state.updateAppError = action.payload;
      })

      .addCase(getListings.pending, (state) => {
        state.loadingListing = true;
      })
      .addCase(getListings.fulfilled, (state, action) => {
        state.listings = action.payload;
        state.listingError = null;
        state.loadingListing = false;
      })
      .addCase(getListings.rejected, (state, action) => {
        state.listings = null;
        state.listingError = action.payload;
        state.loadingListing = false;
      })

      .addCase(getRentals.pending, (state) => {
        state.loadingRentals = true;
      })
      .addCase(getRentals.fulfilled, (state, action) => {
        state.rentals = action.payload;
        state.rentalsError = null;
        state.loadingRentals = false;
      })
      .addCase(getRentals.rejected, (state, action) => {
        state.rentals = null;
        state.rentalsError = action.payload;
        state.loadingRentals = false;
      });
    // .addCase(logout.fulfilled, (state, action) => {
    //   // Update state with data from the rejected action
    //   return initialState;
    // });
  },
});

export default todoSlice.reducer;
